export const GET_SIGNATORIES = "GET_SIGNATORIES";
export const GET_MY_SIGNATORIES = "GET_MY_SIGNATORIES";
export const GET_SIGNATORY_BY_ID = "GET_SIGNATORY_BY_ID";
export const UPDATE_SIGNATORY = "UPDATE_SIGNATORY";
export const DELETE_SIGNATORY = "DELETE_SIGNATORY";
export const CREATE_SIGNATORY = "CREATE_SIGNATORY";
